import { render, staticRenderFns } from "./ispServiceDetail.vue?vue&type=template&id=8f6a2202&scoped=true&"
import script from "./ispServiceDetail.vue?vue&type=script&lang=js&"
export * from "./ispServiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./ispServiceDetail.vue?vue&type=style&index=0&id=8f6a2202&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6a2202",
  null
  
)

export default component.exports